var voted_users_rtlignore_default = {
  "container": "-BUjl",
  "webview": "u8EaZ",
  "avatar_list": "FFKIQ",
  "avatar": "_2H7An",
  "user_avatar": "kcdD7",
  "modal": "-oTyY",
  "voted_users_modal": "_9rND4",
  "overlay": "Ac9-3",
  "user_card": "em2LM",
  "user_name": "_1mYSm",
  "voted_users_modal_header": "LoXCa",
  "cta": "BqVgx",
  "close_icon": "TSlFi",
  "title": "lxMW6",
  "member_list_container": "OWs1h",
  "member_list": "z4odT",
  "loader": "n3sdm",
  "anonymous_counter": "Imy3G",
  "spinner": "_0RCac",
  "spin": "ShYEG"
};
export {
  voted_users_rtlignore_default as default
};
//# sourceMappingURL=voted-users.rtlignore-scss.js.map
